import React, { Component } from 'react';
import {Icon} from "semantic-ui-react";

export default class MyMessage extends Component {
  render() {
    let textAlign = this.props.textAlign;
    let divStyle = {};
    if (textAlign !== undefined) {
      divStyle = {textAlign: textAlign};
    }

    return (
      <div style={divStyle}>
        {this.props.icon ? <Icon name={this.props.iconName || null} color={(this.props.style) ? this.props.style.color : null}/> : null }
        <p style={this.props.style}>{this.props.message}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Message/index.js